<lib-subheadline [subheadline]="'aiProfileMatching.improveResult'"></lib-subheadline>

@if (summary) {
  <div class="improve-result__summary">
    <div class="improve-result__summary-stats">
      <span>{{ 'aiProfileMatching.wordCount' | translate }}: {{ summary.original_word_count }}
        → {{ summary.improved_word_count }}
        ({{ summary.change_percentage > 0 ? '+' : '' }}{{ summary.change_percentage }}%)</span>
      <span>{{ 'aiProfileMatching.originalScore' | translate }}: {{ summary.original_score }}/100</span>
    </div>
    @if (summary.focus_areas.length > 0) {
      <div class="improve-result__summary-section">
        <strong>{{ 'aiProfileMatching.focusAreas' | translate }}:</strong>
        @for (area of summary.focus_areas; track area; let last = $last) {
          <span>{{ area }}{{ last ? '' : ', ' }}</span>
        }
      </div>
    }
    @if (summary.key_improvements.length > 0) {
      <div class="improve-result__summary-section">
        <strong>{{ 'aiProfileMatching.keyImprovements' | translate }}:</strong>
        <ul class="improve-result__summary-list">
          @for (improvement of summary.key_improvements; track improvement) {
            <li>{{ improvement }}</li>
          }
        </ul>
      </div>
    }
  </div>
}

@if (hunks.length > 0) {
  <lib-subheadline [subheadline]="'aiProfileMatching.changes'"></lib-subheadline>

  @for (hunk of hunks; track hunk.id; let last = $last) {
    <mat-card
      appearance="outlined"
      class="improve-result__hunk"
      [ngClass]="{'improve-result__hunk--accepted': getDecision(hunk.id) === 'accepted', 'improve-result__hunk--rejected': getDecision(hunk.id) === 'rejected'}"
    >
      <mat-card-header>
        <mat-card-title class="improve-result__hunk-tag improve-result__hunk-tag--{{ hunk.tag }}">
          {{ hunk.tag }}
        </mat-card-title>
        <div class="improve-result__hunk-actions">
          <button
            mat-icon-button
            [matTooltip]="'aiProfileMatching.acceptHunk' | translate"
            [ngClass]="{'improve-result__action--active-accept': getDecision(hunk.id) === 'accepted'}"
            (click)="accept(hunk.id)"
            [disabled]="isApplying"
          >
            <mat-icon>check_circle</mat-icon>
          </button>
          <button
            mat-icon-button
            [matTooltip]="'aiProfileMatching.rejectHunk' | translate"
            [ngClass]="{'improve-result__action--active-reject': getDecision(hunk.id) === 'rejected'}"
            (click)="reject(hunk.id)"
            [disabled]="isApplying"
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
      </mat-card-header>
      <div class="improve-result__diff">
        @if (hunk.original_lines) {
          <div class="improve-result__diff-section improve-result__diff-section--original">
            <span class="improve-result__diff-label">{{ 'aiProfileMatching.diffOriginal' | translate }}</span>
            <pre>{{ hunk.original_lines }}</pre>
          </div>
        }
        @if (hunk.improved_lines) {
          <div class="improve-result__diff-section improve-result__diff-section--improved">
            <span class="improve-result__diff-label">{{ 'aiProfileMatching.diffImproved' | translate }}</span>
            <pre>{{ hunk.improved_lines }}</pre>
          </div>
        }
      </div>
    </mat-card>
    @if (!last) {
      <mat-divider></mat-divider>
    }
  }

  <div class="improve-result__apply-container">
    <button
      mat-flat-button
      class="improve-result__apply"
      (click)="apply()"
      [disabled]="!allHunksDecided || isApplying"
    >
      <span class="improve-result__button-content">
        @if (isApplying) {
          <mat-spinner diameter="20"></mat-spinner>
          {{ 'aiProfileMatching.applying' | translate }}
        } @else {
          {{ 'aiProfileMatching.applyDecisions' | translate }}
        }
      </span>
    </button>
    @if (!allHunksDecided) {
      <span class="improve-result__apply-hint">
        {{ 'aiProfileMatching.decideAllHunks' | translate }}
      </span>
    }
  </div>
}

<lib-subheadline
  [subheadline]="appliedProfile ? 'aiProfileMatching.finalProfile' : 'aiProfileMatching.improvedProfile'"></lib-subheadline>
<div class="improve-result__profile">
  <pre>{{ appliedProfile ?? improvedProfile }}</pre>
</div>
<button mat-flat-button class="improve-result__download" (click)="downloadProfile()">
  {{ 'aiProfileMatching.downloadProfile' | translate }}
</button>
<button mat-flat-button class="improve-result__export" (click)="exportProfile()">
  {{ 'aiProfileMatching.exportProfile' | translate }}
</button>
